(function () {
  const initProductAccordion = () => {
	document.querySelector('.product__info-container .about')?.classList.add('about--first');
	document.querySelector('.product__info-container .about:last-of-type')?.classList.add('about--last');
	$(".about__accordion-toggle").click(function () {
		if (!$(this).hasClass("active")) {
			$(this).addClass("active");
			$(this)
				.siblings(".about__accordion-description")
				.eq($(this).index())
				.stop()
				.slideDown(300);
		} else {
			$(this).removeClass("active");
			$(this).siblings(".about__accordion-description").stop().slideUp(300);
		}
	});
  };

  const initLightbox = () => {
    const lightbox = document.getElementById('sc-lightbox');
    if (!lightbox) return;

    const bg = lightbox.querySelector('.sc-lightbox__bg');
    const btnClose = lightbox.querySelector('.sc-lightbox__close');
    const btnPrev = lightbox.querySelector('.sc-lightbox__prev');
    const btnNext = lightbox.querySelector('.sc-lightbox__next');
    const counter = lightbox.querySelector('.sc-lightbox__counter');
    const sliderEl = lightbox.querySelector('.js-sc-slider');

    let swiper = null;

    const initSwiper = () => {
      if (swiper) return;
      swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        loop: false,
        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },
        on: {
          slideChange: () => { updateCounter(); resetZoom(); },
        }
      });
    };

    const updateCounter = () => {
      if (!swiper) return;
      const total = swiper.slides.length;
      counter.textContent = total > 1 ? `${swiper.realIndex + 1} / ${total}` : '';
    };

    const show = (mediaId) => {
      lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      initSwiper();

      if (mediaId) {
        const slideIndex = Array.from(sliderEl.querySelectorAll('.sc-lightbox__slide'))
          .findIndex(s => s.dataset.mediaId === String(mediaId));
        if (slideIndex > -1) swiper.slideTo(slideIndex, 0);
      }

      updateCounter();
    };

    const hide = () => {
      lightbox.setAttribute('hidden', '');
      document.body.style.overflow = '';
      resetZoom();
    };

    // Zoom sur l'image dans le lightbox
    let isZoomed = false;

    const resetZoom = () => {
      const img = sliderEl.querySelector('.swiper-slide-active img');
      if (img) {
        img.style.transform = '';
        img.style.transformOrigin = '';
        img.style.cursor = 'zoom-in';
      }
      isZoomed = false;
    };

    sliderEl.addEventListener('click', (e) => {
      const img = e.target.closest('.sc-lightbox__slide img');
      if (!img) return;
      const slide = img.closest('.sc-lightbox__slide');

      if (isZoomed) {
        img.style.transform = 'scale(1)';
        slide.style.cursor = 'zoom-in';
        isZoomed = false;
        img.addEventListener('transitionend', () => {
          img.style.transform = '';
          img.style.transformOrigin = '';
        }, { once: true });
        return;
      }

      const rect = img.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(2.5)';
      slide.style.cursor = 'zoom-out';
      isZoomed = true;
    });

    // Ouvrir au clic sur une image de la grid
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('.product__media-list .product__modal-opener--image');
      if (!opener) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const mediaId = opener.querySelector('.product__media-toggle')?.dataset.mediaId;
      show(mediaId);
    }, true);

    bg.addEventListener('click', hide);
    btnClose.addEventListener('click', hide);

    document.addEventListener('keydown', (e) => {
      if (lightbox.hasAttribute('hidden')) return;
      if (e.key === 'Escape') hide();
      if (e.key === 'ArrowLeft') swiper?.slidePrev();
      if (e.key === 'ArrowRight') swiper?.slideNext();
    });
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initLightbox();
  });

  initProductAccordion();
  initLightbox();
})();
